import { render, staticRenderFns } from "./DeleteLeadStatus.vue?vue&type=template&id=3975e286&scoped=true"
import script from "./DeleteLeadStatus.vue?vue&type=script&lang=js"
export * from "./DeleteLeadStatus.vue?vue&type=script&lang=js"
import style0 from "./DeleteLeadStatus.vue?vue&type=style&index=0&id=3975e286&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3975e286",
  null
  
)

export default component.exports